var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as actions from '../actions/menus/managedMenu';


var intialState = {
  isFetching: false
};

// $FlowFixMe
export var managedMenu = function managedMenu() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : intialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.MENU_REQUEST:
      return _extends({}, state, {
        isFetching: true
      });
    case actions.MENU_SUCCESS:
      return {
        menu: _extends({}, action.payload),
        isFetching: false
      };
    case actions.MENU_FAILURE:
      return _extends({}, state, {
        menu: {},
        isFetching: false,
        error: action.error
      });
    default:
      return state;
  }
};